<template>
  <button :type="type" :disabled="disabled" class="top-0 relative transition-inset text-center"
    :class="{ 'rounded-lg py-2': !flat && !outline,
    'px-3': !flat && !outline && !icon,
    'bg-gray-200 hover:bg-gray-100': !flat && !outline && !disabled && color === 'gray',
    'bg-red hover:bg-red-light': !flat && !outline && !disabled && color === 'danger',
    'bg-gray-100 text-gray-400': !flat && !outline && disabled,

    'text-black hover:text-gray-500': !disabled && flat && color === 'gray',
    'text-red hover:text-red-light': !disabled && flat && color === 'danger',
    'text-gray-400': flat && disabled,

    'text-white': !disabled && !flat && !outline && color === 'danger',

    'ring-2 ring-inset rounded-lg': outline,
    'text-gray-700 hover:bg-gray-50 ring-gray-200': outline && !disabled && color === 'gray',
    'text-red hover:bg-red-ultralight ring-red': outline && !disabled && color === 'danger',
    'text-gray-400 ring-gray-400': outline && disabled,

    'px-4': !flat && !icon,
    'w-9': !flat && icon,
        
    'cursor-default': disabled}"
  >
    <div class="icon inline" :class="{ 'icon-left': !icon }">
      <slot name="iconLeft"></slot>
    </div>

    <div v-if="!icon" class="inline-block">
      <slot></slot>
    </div>

    <div class="icon inline" :class="{ 'icon-right': !icon }">
      <slot name="iconRight"></slot>
    </div>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    type: {
      type: String,
      default: 'button'
    },
    flat: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'gray' // TO DO: change to primary.
    },
    icon: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="postcss">
.icon > * {
  @apply h-5 inline mb-1;
}

.icon-left > * {
  @apply mr-2;
}

.icon-right > * {
  @apply ml-2;
}
</style>
